/*
Sohel 04/13/2023 2698964415 Added Type Field in Filter Criteria
Sohel 04/13/2023 2698964415 Added Field Type Issue
Akhila 04/28//2023 2698964415 modified in field type and sql output
Akhila 05/04/2023 2698964415 to field value changes
Sohel 05/05/2023 2698964415 to field value changes
Sohel 05/05/2023 2698964415 to field value changes
Sohel 05/10/2023 2698811066 Fixed Type Payload Issue
Sohel 05/11/2023 2698811066 Sql Output Changes
Akhila 06/02/2023 2698811066 Date field captial and is not bug fixed
Akhila 06/02/2023 2698811066 changed field type date between and not between
Akhila 06/03/2023 2698811066 between T+/T- and manually date issue fix and label change
Akhila 06/09/2023 2698811066 bug fix is not sql output
Akhila 06/16/2023 2698811066 added TODAY and T in sql output
Akhila 06/21/2023 2698811066 modified field type sql output bug fix
Sohel 06/21/2023 2698811066 added Repository name
Akhila 06/22/2023 2698811066 modified sql output for text field type
Akhila 06/26/2023 2698811066 is not changes added "="
Sohel 10/13/2023 2698811066 Filter Condition Changes
Sohel 10/16/2023 2698811066 Field Right Side SQL Output Changes
Sohel 10/16/2023 2698811066 SQl Output value Changes
Sohel 10/16/2023 2698811066 Fixed Date Format issue
uday 10/19/2023 2698811066 fixed ui bug in add filter inputfield
uday 10/19/2023 2698811066 fixed add label name in add filter inputfield
Sohel 10/20/2023 2698811066 Filter Rule Fixed Date Issue.
*/
import React, {useContext} from 'react';
import {TextField} from '@material-ui/core';
import moment from 'moment';
import {ErrorMessage} from './ErrorMessage';
import GuiAutoComplete from '../FormComponents/GuiAutoComplete';
import {ThemeContext} from '../../themes/ThemeProvider';
// import { NumberFormatter } from "../../../components/UserDefinedForm/AppTextInputComponents";

export const formatDate = (val) => {
  return moment(val).format('MM/DD/YYYY');
};

export const getValue = (values) => {
  const a = values?.split(' ')?.join('');
  const dateValue = values?.length > 1 ? values?.slice(0, 5) : '';
  if (dateValue?.toUpperCase() === 'TODAY') {
    return a?.replace(dateValue, 'cast(now()as date)');
  } else if (values?.charAt(0)?.toUpperCase() === 'T') {
    return a?.replace(values?.charAt(0), 'cast(now()as date)');
  } else {
    return `'${values}'`;
  }
};
export const getOptions = (type) => {
  switch (type) {
  case 'text':
  case 'ssn':
  case 'phone':
    return [
      {label: 'Is', value: '='},
      {label: 'Is not', value: '<>'},
      {label: 'Contain', value: 'contains'},
      {label: 'Doesn\'t contain', value: 'notContains'},
      {label: 'In', value: 'in'},
      {label: 'Not in', value: 'notIn'},
      {label: 'Starts with', value: 'startsWith'},
      {label: 'Ends with', value: 'endsWith'},
      {label: 'Is Blank', value: 'isBlank'},
      {label: 'Is Not Blank', value: 'isNotBlank'},
    ];
  case 'number':
  case 'amount':
    return [
      {label: 'Is', value: '='},
      {label: 'Is not', value: '<>'},
      {label: 'Less than', value: '<'},
      {label: 'Greater than', value: '>'},
      {label: 'Less than equal', value: '<='},
      {label: 'Greater than equal', value: '>='},
      {label: 'Between', value: 'BETWEEN'},
      {label: 'Not between', value: 'NOT BETWEEN'},
      {label: 'Is Blank', value: 'isBlank'},
      {label: 'Is Not Blank', value: 'isNotBlank'},
    ];
  case 'date':
    return [
      {label: 'Is', value: '='},
      {label: 'Is not', value: '<>'},
      {label: 'Less than', value: '<'},
      {label: 'Greater than', value: '>'},
      {label: 'Less than equal', value: '<='},
      {label: 'Greater than equal', value: '>='},
      {label: 'Between', value: 'BETWEEN'},
      {label: 'Not between', value: 'NOT BETWEEN'},
      {label: 'Is Blank', value: 'isBlank'},
      {label: 'Is Not Blank', value: 'isNotBlank'},
    ];
  default:
    return [
      {label: 'Is', value: '='},
      {label: 'Is not', value: '<>'},
      {label: 'Contain', value: 'contains'},
      {label: 'Doesn\'t contain', value: 'notContains'},
      {label: 'In', value: 'in'},
      {label: 'Not in', value: 'notIn'},
      {label: 'Starts with', value: 'startsWith'},
      {label: 'Ends with', value: 'endsWith'},
      {label: 'Is Blank', value: 'isBlank'},
      {label: 'Is Not Blank', value: 'isNotBlank'},
    ];
  }
};

export const GetFields = ({
  type,
  fileType,
  rule,
  handleUpdateRule,
  name,
  name1,
  error,
  handleBlur,
  mapFieldsData,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const hideValuesConditions = ['isBlank', 'isNotBlank', 'isEmpty', 'isNotEmpty'];
  const valueErrorMesg = (
    <ErrorMessage render={(msg) => <div className="error-text mt-1">{msg}</div>} name={name} />
  );
  const commonProps = {
    handleBlur,
    fullWidth: true,
  };
  const value1ErrorMesg = (
    <ErrorMessage render={(msg) => <div className="error-text mt-1">{msg}</div>} name={name1} />
  );
  if (fileType === 'file') {
    return (
      <>
        <div>
          <GuiAutoComplete
            classes={{
              popper: classes.popper,
              option: classes.option,
            }}
            value={rule.value || ''}
            name={'value'}
            options={mapFieldsData || []}
            getOptionLabel={(option) => option?.fieldName || ''}
            renderOption={(option) => option?.repositoryName + ' - ' + option?.fieldName}
            size="small"
            autoHighlight
            freeSolo
            filter
            onInputChange={(e, value) => {
              if (!rule.value) return;
              const copy = rule?.value && {...rule.value};
              copy.fieldName = value;
              handleUpdateRule('value', copy || '');
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                InputLabelProps={{
                  shrink: true,
                }}
                onBlur={handleBlur}
                fullWidth
                margin="dense"
                label="To Field Value"
                name="value"
                filterSelectedOptions={false}
                error={error}
                placeholder="Select To Filed Value"
                inputProps={{
                  ...params.inputProps,
                  autoComplete: 'off',
                }}
              />
            )}
            onChange={(_, data) => {
              handleUpdateRule('value', data || '');
            }}
          />
          {valueErrorMesg}
        </div>
      </>
    );
  }
  if (!hideValuesConditions.includes(rule.condition.value)) {
    switch (type) {
    case 'text':
    case 'ssn':
    case 'phone':
      return (
        <>
          <TextField
            {...commonProps}
            label="To field value"
            value={rule.value}
            name={name}
            placeholder="Enter To field value"
            error={error}
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(e) => {
              handleUpdateRule('value', e.target.value);
            }}
          />
          {valueErrorMesg}
        </>
      );
    case 'number':
    case 'amount':
      if (rule.condition.value == 'BETWEEN') {
        return (
          <div className="d-flex">
            <div className="label-text">From</div>
            <div>
              <TextField
                {...commonProps}
                type="number"
                placeholder="Enter value"
                // variant="outlined"
                value={rule.value}
                name={name}
                error={error}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  style: {
                    height: '0px',
                  },
                }}
                onChange={(e) => {
                  handleUpdateRule('value', e.target.value);
                }}
              />
              {valueErrorMesg}
            </div>
            <div className="label-text">To</div>
            <div>
              <TextField
                {...commonProps}
                value={rule.value1}
                type="number"
                placeholder="Enter value"
                // variant="outlined"
                name={`${name}.value1`}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  style: {
                    height: '0px',
                  },
                }}
                onChange={(e) => {
                  handleUpdateRule('value1', e.target.value);
                }}
              />
              {value1ErrorMesg}
            </div>
          </div>
        );
      } else if (rule.condition.value == 'NOT BETWEEN') {
        return (
          <div className="d-flex align-items-center">
            <div className="start-num"></div>
            <div>
              <TextField
                // label="Value"
                {...commonProps}
                type="number"
                name={name}
                placeholder="Enter value"
                // variant="outlined"
                value={rule.value}
                error={error}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  style: {
                    height: '0px',
                  },
                }}
                onChange={(e) => {
                  handleUpdateRule('value', e.target.value);
                }}
              />
              {valueErrorMesg}
            </div>
            <div className="label-text and-value-text">and</div>
            <div>
              <TextField
                {...commonProps}
                value={rule.value1}
                type="number"
                placeholder="Enter value"
                // variant="outlined"
                name={`${name}.value1`}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  style: {
                    height: '0px',
                  },
                }}
                onChange={(e) => {
                  handleUpdateRule('value1', e.target.value);
                }}
              />
              {value1ErrorMesg}
            </div>
          </div>
        );
      } else {
        return (
          <>
            <TextField
              {...commonProps}
              label="Value"
              value={rule.value}
              name={name}
              type="number"
              error={error}
              placeholder="Enter value"
              onChange={(e) => {
                handleUpdateRule('value', e.target.value);
              }}
            />
            {valueErrorMesg}
          </>
        );
      }
    case 'number':
    case 'amount':
      if (rule.condition.value == 'BETWEEN') {
        return (
          <div className="row">
            {/* <div className="label-text">From</div> */}
            <div className="col-md-6">
              <TextField
                {...commonProps}
                type="number"
                placeholder="Enter Value"
                // variant="outlined"
                label="From"
                margin="dense"
                value={rule.value}
                name={name}
                error={error}
                // InputLabelProps={{
                //   shrink: true,
                // }}
                onChange={(e) => {
                  handleUpdateRule('value', e.target.value);
                }}
              />
              {valueErrorMesg}
            </div>
            {/* <div className="label-text">To</div> */}
            <div className="col-md-6">
              <TextField
                {...commonProps}
                value={rule.value1}
                type="number"
                margin="dense"
                placeholder="Enter value"
                label="To"
                // variant="outlined"
                name={`${name}.value1`}
                // InputLabelProps={{
                //   shrink: true,
                // }}
                onChange={(e) => {
                  handleUpdateRule('value1', e.target.value);
                }}
              />
              {value1ErrorMesg}
            </div>
          </div>
        );
      } else if (rule.condition.value == 'NOT BETWEEN') {
        return (
          <div className="row align-items-center">
            {/* <div className="start-num"></div> */}
            <div className="col-md-5">
              <TextField
                // label="Value"
                {...commonProps}
                type="number"
                name={name}
                margin="dense"
                label="From"
                placeholder="Enter Value"
                // variant="outlined"
                value={rule.value}
                error={error}
                // InputLabelProps={{
                //   shrink: true,
                // }}
                // inputProps={{
                //   style: {
                //     height: "0px",
                //   },
                // }}
                onChange={(e) => {
                  handleUpdateRule('value', e.target.value);
                }}
              />
              {valueErrorMesg}
            </div>
            <div className="col-md-1 label-text and-value-text">and</div>
            <div className="col-md-5">
              <TextField
                {...commonProps}
                value={rule.value1}
                type="number"
                placeholder="Enter value"
                margin="dense"
                label="To"
                // variant="outlined"
                name={`${name}.value1`}
                // InputLabelProps={{
                //   shrink: true,
                // }}
                // inputProps={{
                //   style: {
                //     height: "0px",
                //   },
                // }}
                onChange={(e) => {
                  handleUpdateRule('value1', e.target.value);
                }}
              />
              {value1ErrorMesg}
            </div>
          </div>
        );
      } else {
        return (
          <>
            <TextField
              margin="dense"
              placeholder="MM/DD/YYYY or Today or T"
              label="From Field Value"
              name={name}
              value={rule.value}
              onChange={(e) => {
                handleUpdateRule('value', e.target?.value?.toUpperCase());
              }}
              fullWidth
              onBlur={handleBlur}
              error={error}
            />
            <div className="label-text and-datepicker-text">and</div>
            <TextField
              margin="dense"
              placeholder="MM/DD/YYYY or Today or T"
              label="To Field Value"
              name={`${name}.value1`}
              value={rule.value1}
              onChange={(e) => {
                handleUpdateRule('value1', e.target?.value?.toUpperCase());
              }}
              fullWidth
              onBlur={handleBlur}
              error={error}
            />
          </>
        );
      }
    default:
      return (
        <>
          <TextField
            {...commonProps}
            label="Value"
            value={rule.value}
            placeholder="Enter value"
            name={name}
            error={error}
            fullWidth
            onChange={(e) => {
              handleUpdateRule('value', e.target.value);
            }}
          />
          {valueErrorMesg}
        </>
      );
    }
  }
  return null;
};
const numberTypes = ['amount', 'number'];
export const generateSql = (obj, userEnteredValRef, isFilterRules) => {
  let sqlQuery = obj?.field?.globalField;
  const dontConvertLowerCase = ['date', 'number', 'amount', 'email', 'ssn', 'phone'];
  let {
    value,
    value1,
    type,
    // condition: { value: conditionValue },
    condition,
  } = obj;
  const conditionValue = condition?.value ? condition.value : '';
  const currFieldType = obj?.field?.fieldType?.toLowerCase();
  if (typeof value === 'object' && isFilterRules) {
    value = value?.repositoryName + '.' + value?.fieldName;
  } else if (typeof value === 'object') {
    value = value?.fieldName;
  }
  // if (type?.value === "file") {
  //   value = typeof value?.fieldName === "string" ? `${value?.fieldName}` : "";
  //   // value = valueField ? valueField : "";

  //   // if (!dontConvertLowerCase.includes(currFieldType)) {
  //   //   sqlQuery = `lower(${obj?.field?.globalField})`;
  //   // }
  //   // sqlQuery += conditionValue;
  //   // if (["in", "notIn"]?.includes(conditionValue)) {
  //   //   sqlQuery += " " + `('${value.toLowerCase()}')`;
  //   // } else {
  //   sqlQuery += " = " + `${value}`;
  //   console.log("file", "filll")
  //   // }
  // } else {
  if (value && currFieldType !== 'date' && type?.value !== 'file') {
    value = value.toLowerCase();
  }
  if (value1 && currFieldType !== 'date' && type?.value !== 'file') {
    value1 = value1.toLowerCase();
  }

  if (!dontConvertLowerCase.includes(currFieldType)) {
    sqlQuery = `lower(${obj?.field?.globalField})`;
  }
  const fileCondition = type?.value === 'file';

  if (conditionValue) {
    switch (conditionValue) {
    case '=':
      sqlQuery += ' = ';
      if (currFieldType === 'date') {
        // sqlQuery += " " + `'${formatDate(value)}'`;
        if (fileCondition) {
          sqlQuery += ' ' + `${value}`;
        } else if (
          value?.slice(0, 5)?.toUpperCase() === 'TODAY' ||
            value?.charAt(0)?.toUpperCase() === 'T'
        ) {
          // sqlQuery += " " + " now() " + `${value}`;
          sqlQuery += `${getValue(value)}`;
        } else {
          sqlQuery += `'${value}'`;
        }
      } else if (fileCondition && ['text']?.includes(currFieldType)) {
        sqlQuery += ' ' + `lower(${value})`;
      } else if (fileCondition) {
        sqlQuery += ' ' + `${value}`;
      } else {
        sqlQuery += ' ' + `'${value.toLowerCase()}'`;
      }
      break;
    case '<>':
      sqlQuery += ' ' + conditionValue;
      if (currFieldType === 'date') {
        sqlQuery = `( ${obj.field.globalField}`;
        if (fileCondition) {
          sqlQuery = `${obj.field.globalField}`;
          sqlQuery += ` <> ${value}`;
        } else if (
          value?.slice(0, 5)?.toUpperCase() === 'TODAY' ||
            value?.charAt(0)?.toUpperCase() === 'T'
        ) {
          // sqlQuery += " " + " now() " + `${value}`;
          // sqlQuery += `${getValue(value)}`;
          sqlQuery += ' ' + conditionValue;
          sqlQuery += ` ${getValue(value)} or ${obj.field.globalField} is null )`;
        } else {
          // sqlQuery += ` now() ${value} or ${obj.field.globalField} is null )`;
          sqlQuery += ' ' + conditionValue;
          sqlQuery += ` '${value}' or ${obj.field.globalField} is null )`;
        }
      } else if (fileCondition && ['text']?.includes(currFieldType)) {
        sqlQuery += ' ' + `lower(${value})`;
      } else if (fileCondition) {
        sqlQuery += ' ' + `${value}`;
      } else {
        sqlQuery = `( ${obj.field.globalField}`;
        if (!dontConvertLowerCase.includes(currFieldType)) {
          sqlQuery = `( lower(${obj.field.globalField})`;
        }

        sqlQuery += ' ' + conditionValue;
        sqlQuery += ' ' + `'${value}' or ${obj.field.globalField} is null )`;
      }
      break;
    case 'contains':
      sqlQuery += ' LIKE ';
      sqlQuery += ` '%${value}%'`;

      break;
    case 'notContains':
      sqlQuery = `( ${obj.field.globalField}`;
      if (!dontConvertLowerCase.includes(currFieldType)) {
        sqlQuery = `( lower(${obj.field.globalField})`;
      }
      sqlQuery += ' NOT LIKE ';
      sqlQuery += ` '%${value}%'  or ${obj.field.globalField} is null )`;

      break;
    case 'startsWith':
      sqlQuery += ' LIKE ';
      sqlQuery += ` '${value}%'`;

      break;
    case 'endsWith':
      sqlQuery += ' LIKE ';
      sqlQuery += ` '%${value}'`;

      break;
    case 'BETWEEN':
    case 'NOT BETWEEN':
      if (currFieldType === 'date') {
        // sqlQuery += " " + conditionValue + " ";
        //   sqlQuery += `'${formatDate(value)}'` + " AND " + `'${value1 ? formatDate(value1) : ""}'`;
        // }
        // if (value?.charAt(0) !== "T") {
        //   console.log("simple");
        //   sqlQuery += " " + conditionValue + " ";
        //   sqlQuery += `'${value}' AND '${value1}'`;
        //   // sqlQuery += `'${value} or ${obj.field.globalField} is null )'`;
        // }
        if (value?.charAt(0)?.toUpperCase() !== 'T' && value1?.charAt(0)?.toUpperCase() !== 'T') {
          sqlQuery += ' ' + conditionValue + ' ';
          sqlQuery += `'${value}' AND '${value1}'`;
        } else if (
          value?.slice(0, 5)?.toUpperCase() === 'TODAY' ||
            value?.charAt(0)?.toUpperCase() === 'T' ||
            value1?.slice(0, 5)?.toUpperCase() === 'TODAY' ||
            value1?.charAt(0)?.toUpperCase() === 'T'
        ) {
          // sqlQuery += " " + " now() " + `${value}`;
          sqlQuery += ' ' + conditionValue + ' ';
          sqlQuery += `${getValue(value)} AND ${getValue(value1)}`;
        }
      } else {
        sqlQuery += ' ' + conditionValue + ' ';
        sqlQuery += `${getValue(value)}` + ' AND ' + `${getValue(value1)}`;
      }
      break;
    case 'isBlank':
      if (currFieldType != 'date') {
        sqlQuery = `${obj.field.globalField} IS NULL OR ${obj.field.globalField} = ''`;
      } else {
        sqlQuery = `${obj.field.globalField} IS NULL`;
      }
      if (numberTypes.includes(currFieldType)) {
        sqlQuery = `${obj.field.globalField} IS NULL OR ${obj.field.globalField} = '0'`;
      }
      break;
    case 'isNotBlank':
      if (currFieldType != 'date') {
        sqlQuery = `( ${obj.field.globalField} IS NOT NULL AND ${obj.field.globalField} != '' )`;
      } else {
        sqlQuery = `( ${obj.field.globalField} IS NOT NULL )`;
      }

      if (numberTypes.includes(currFieldType)) {
        sqlQuery = `( ${obj.field.globalField} IS NOT NULL AND ${obj.field.globalField} != '0' )`;
      }
      break;
    case 'in':
      sqlQuery += ' IN (';
      const inSplitArr = value.split(',');
      inSplitArr.forEach((el, i) =>
        i === inSplitArr.length - 1 ?
          (sqlQuery += `'${el?.trim()}'`) :
          (sqlQuery += `'${el?.trim()}',`),
      );
      sqlQuery += ')';
      break;
    case 'notIn':
      sqlQuery = `( ${obj.field.globalField}`;
      if (!dontConvertLowerCase.includes(currFieldType)) {
        sqlQuery = `( lower(${obj.field.globalField})`;
      }
      sqlQuery += ' NOT IN (';
      const splitArr = value.split(',');
      splitArr.forEach((el, i) =>
        i === splitArr.length - 1 ?
          (sqlQuery += `'${el?.trim()}'`) :
          (sqlQuery += `'${el?.trim()}',`),
      );
      sqlQuery += `) or ${obj.field.globalField} is null )`;
      break;
    default:
      if (currFieldType === 'date') {
        sqlQuery += ' ' + conditionValue;
        // sqlQuery += ` '${formatDate(value)}'`;
        // sqlQuery += " " + `'${formatDate(value)}'`;
        if (fileCondition) {
          sqlQuery += ' ' + `${value}`;
        } else if (
          value?.slice(0, 5)?.toUpperCase() === 'TODAY' ||
            value?.charAt(0)?.toUpperCase() === 'T'
        ) {
          // sqlQuery += " " + " now() " + `${value}`;
          sqlQuery += `${getValue(value)}`;
        } else {
          // sqlQuery += " " + " now() " + `${value}`;
          sqlQuery += `'${value}'`;
        }
      } else if (fileCondition) {
        sqlQuery += ' ' + conditionValue;
        sqlQuery += ' ' + `${value}`;
      } else {
        sqlQuery += ' ' + conditionValue;
        sqlQuery += ' ' + `'${value}'`;
      }
    }
  }

  obj.sqlValue = sqlQuery;
};
